import { SignupActions } from '../actions/SignUpActions';

export const CSS_TRANSITIONS = {
    RIGHT_TO_LEFT: 'RIGHT_TO_LEFT',
    LEFT_TO_RIGHT: 'LEFT_TO_RIGHT',
    NONE: 'NONE',
};

const initialState = {
    cssTransition: CSS_TRANSITIONS.NONE,
    subpatientCreationSuccess: false,
    subpatients: [],
    mainPatientId: -1,
    showInsuranceCardLightBox: false,
    showLoginModal: false,
};

export const signupReducer = (state = initialState, action) => {
    switch (action.type) {
        case SignupActions.SHOW_LOGIN_MODAL: {
            const newState = {
                ...state,
                sawLoginModal: true,
                shouldShowLoginModal: true,
            };
            return newState;
        }

        case SignupActions.CLOSE_LOGIN_MODAL: {
            const newState = {
                ...state,
                shouldShowLoginModal: false,
            };
            return newState;
        }

        case SignupActions.SETUP_CSS_TRANSITION_TO_NEXT_PAGE: {
            const newState = {
                ...state,
                cssTransition: CSS_TRANSITIONS.LEFT_TO_RIGHT,
            };

            return newState;
        }

        case SignupActions.SETUP_CSS_TRANSITION_TO_PREV_PAGE: {
            const newState = {
                ...state,
                cssTransition: CSS_TRANSITIONS.RIGHT_TO_LEFT,
            };

            return newState;
        }

        default:
            return state;
    }
};
